<template>
  <div class="animated fadeIn">
    <b-row class="mt-3" >
      <b-col sm="12">
        <b-card class="bg-info">
          <b-row>
            <b-col>
              <h5 class="text-center">
                <a href="https://api.whatsapp.com/send?phone=558199719158&text=Tenho%20uma%20d%C3%BAvida%20sobre%20o%20Sleeker%2C%20pode%20me%20ajudar%3F" style="color: white;">Abaixo as dúvidas mais frequentes. <b>Mas se você preferir, clique aqui para falar com nossa equipe.</b></a>
              </h5>
            </b-col>
          </b-row>
        </b-card>
        <b-card>
          <div role="tablist">
            <b-card ref="accordion1" no-body class="mb-1">
              <b-card-header class="p-1" role="tab">
                <div v-b-toggle.accordion1>
                  <p> #1 Como funciona?</p>
                </div>
              </b-card-header>
              <b-collapse id="accordion1" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <p class="card-text">
                    O Sleeker produz diariamente conteúdo pronto e atualizado diariamente para Personal Trainers, Nutricionistas e Academias publicarem nas redes sociais, incluindo artes com textos editáveis. Personalize com a sua logo, sua foto, cores e fontes preferidas.
                  </p>
                </b-card-body>
              </b-collapse>
            </b-card>
            <b-card ref="accordion2" no-body class="mb-1">
                <b-card-header  class="p-1" role="tab">
                  <div v-b-toggle.accordion2>
                    <p> #2 Não recebi e-mail de confirmação</p>
                  </div>
                </b-card-header>
                <b-collapse id="accordion2" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <p class="card-text">
                      Será que ele não foi parar na caixa de spam? Ou de promoções? Se ainda assim não encontrar, <a href="https://api.whatsapp.com/send?phone=558199719158&text=Tenho%20uma%20d%C3%BAvida%20sobre%20o%20Sleeker%2C%20pode%20me%20ajudar%3F">clique aqui</a> para falar com nossa equipe.
                    </p>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card ref="accordion3" no-body class="mb-1">
                <b-card-header  class="p-1" role="tab">
                  <div v-b-toggle.accordion3>
                    <p> #3 Tenho um problema com a senha</p>
                  </div>
                </b-card-header>
                <b-collapse id="accordion3" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <p class="card-text">
                      Não chegou o e-mail de recuperação para você? Nem na caixa de spam ou de promoções? Se não, <a href="https://api.whatsapp.com/send?phone=558199719158&text=Tenho%20uma%20d%C3%BAvida%20sobre%20o%20Sleeker%2C%20pode%20me%20ajudar%3F">clique aqui</a> para falar com nossa equipe.
                    </p>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card ref="accordion4" no-body class="mb-1">
                <b-card-header  class="p-1" role="tab">
                  <div v-b-toggle.accordion4>
                    <p> #4 Paguei mas continuo sem acesso</p>
                  </div>
                </b-card-header>
                <b-collapse id="accordion4" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <p class="card-text">
                      O PagSeguro leva 2 dias para aprovar, mas se você nos enviar o comprovante a gente consegue liberar rapidinho!
                      <br/>
                      <br/>
                      Manda para sleeker@arsenaltec.com ou <a href="https://api.whatsapp.com/send?phone=558199719158&text=Tenho%20uma%20d%C3%BAvida%20sobre%20o%20Sleeker%2C%20pode%20me%20ajudar%3F">clique aqui</a> para falar com a gente.
                    </p>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card ref="accordion5" no-body class="mb-1">
                <b-card-header  class="p-1" role="tab">
                  <div v-b-toggle.accordion5>
                    <p> #5 Posso usar o conteúdo de forma ilimitada?</p>
                  </div>
                </b-card-header>
                <b-collapse id="accordion5" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <p class="card-text">
                      Apenas os clientes do Plano FREE PASS que só é aberto periodicamente. Todos os outros planos têm algum tipo de limite, muito superior ao que você precisa para colocar sua estratégia em prática.
                    </p>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card ref="accordion6" no-body class="mb-1">
                <b-card-header  class="p-1" role="tab">
                  <div v-b-toggle.accordion6>
                    <p> #6 Posso pagar com cartão?</p>
                  </div>
                </b-card-header>
                <b-collapse id="accordion6" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <p class="card-text">
                      Sim. O pagamento é via PagSeguro e você pode pagar por boleto ou cartão de crédito.
                    </p>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card ref="accordion7" no-body class="mb-1">
                <b-card-header  class="p-1" role="tab">
                  <div v-b-toggle.accordion7>
                    <p> #7 Como faço o pagamento?</p>
                  </div>
                </b-card-header>
                <b-collapse id="accordion7" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <p class="card-text">
                      Você faz pela própria ferramenta: opção <b>Assinar</b> no menu.
                      Ou <a href="/payments">clique aqui</a>
                    </p>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card ref="accordion8" no-body class="mb-1">
                <b-card-header  class="p-1" role="tab">
                  <div v-b-toggle.accordion8>
                    <p> #8 Qual o valor?</p>
                  </div>
                </b-card-header>
                <b-collapse id="accordion8" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <p class="card-text">
                      Existem três tipos de plano. Premium, VIP e FREE PASS. Os planos Premium e VIP estão sempre disponíveis em planos de 3, 6 ou 12 meses. Já o plano FREE PASS só é disponibilizado esporadicamente e pelo período de 12 meses.
                      <br/>
                      <br/>
                      <a href="/payments">Clique aqui para ver o preço de cada plano</a>
                    </p>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card ref="accordion9" no-body class="mb-1">
                <b-card-header  class="p-1" role="tab">
                  <div v-b-toggle.accordion9>
                    <p> #9 Posso colocar minha logo?</p>
                  </div>
                </b-card-header>
                <b-collapse id="accordion9" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <p class="card-text">
                      Sim! Todos os posts podem ser personalizados com a sua logo.
                    </p>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card ref="accordion10" no-body class="mb-1">
                <b-card-header  class="p-1" role="tab">
                  <div v-b-toggle.accordion10>
                    <p> #10 Posso alterar a cor?</p>
                  </div>
                </b-card-header>
                <b-collapse id="accordion10" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <p class="card-text">
                    Sim. Os posts têm a cor personalizável e, se não encontrar sua cor na nossa paleta, basta pedir que nós acrescentaremos. 
                    <br/>
                    <br/>
                    Se por acaso você encontrar um post que não permite a alteração de cor, é porque ele é muito antigo e ainda não foi atualizado pela nossa equipe. Também basta solicitar e nós faremos a atualização. Pode ser pelo e-mail sleeker@arsenaltec.com ou <a href="https://api.whatsapp.com/send?phone=558199719158&text=Tenho%20uma%20d%C3%BAvida%20sobre%20o%20Sleeker%2C%20pode%20me%20ajudar%3F">clicando aqui</a>.
                    </p>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card ref="accordion11" no-body class="mb-1">
                <b-card-header  class="p-1" role="tab">
                  <div v-b-toggle.accordion11>
                    <p> #11 Posso colocar minha foto?</p>
                  </div>
                </b-card-header>
                <b-collapse id="accordion11" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <p class="card-text">
                      Sim.
                      <br/>
                      <br/>
                      Todos os posts permitem que você coloque a sua foto. Entretanto, essa possibilidade pode vir de duas formas diferentes. 
                      <br/>
                      <br/>
                      Alguns posts permitem que você troque a foto do fundo, e outros permitem que você coloque a sua foto sem fundo sobre o post. Na tela de tutorial ensinamos como você pode fazer as duas coisas: <a href="/tutorial">clique aqui</a>.
                    </p>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card ref="accordion12" no-body class="mb-1">
                <b-card-header  class="p-1" role="tab">
                  <div v-b-toggle.accordion12>
                    <p> #12 Posso sugerir postagens à equipe do Sleeker?</p>
                  </div>
                </b-card-header>
                <b-collapse id="accordion12" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <p class="card-text">
                      Sim! Basta acessar a opção <b>Sugerir Sleeker</b> no menu. Se puder sugerir também uma fonte de pesquisa, melhor ainda 🙂
                    </p>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card ref="accordion13" no-body class="mb-1">
                <b-card-header  class="p-1" role="tab">
                  <div v-b-toggle.accordion13>
                    <p> #13 Só usando os posts do Sleeker eu vou vender mais?</p>
                  </div>
                </b-card-header>
                <b-collapse id="accordion13" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <p class="card-text">
                      Não. O Sleeker tem tudo o que você precisa para colocar as estratégias que funcionam em prática, mas não faz mágica. Se você não sabe por qual estratégia começar, nós temos dois cursos gratuitos para te ajudar. 
                    </p>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card ref="accordion14" no-body class="mb-1">
                <b-card-header  class="p-1" role="tab">
                  <div v-b-toggle.accordion14>
                    <p> #14 Posso comprar material de desafio avulso? Ele expira?</p>
                  </div>
                </b-card-header>
                <b-collapse id="accordion14" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <p class="card-text">
                     Pode sim! O Material para Grupos de Desafio custa R$150 avulso. O acesso fica disponível por 6 meses.
                      <br/>
                      <br/>
                      Recomendamos, no entanto, que avalie se não é uma melhor opção realizar a compra do plano VIP Semestral que dá também acesso aos posts e gerador de ebooks do Sleeker, além do material para grupos, e custa R$237. 
                    </p>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card ref="accordion15" no-body class="mb-1">
                <b-card-header  class="p-1" role="tab">
                  <div v-b-toggle.accordion15>
                    <p> #15 Posso comprar ebook avulso?</p>
                  </div>
                </b-card-header>
                <b-collapse id="accordion15" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <p class="card-text">
                      Sim. Se você não for cliente do Sleeker, cada ebook custa R$27. Se for cliente Premium, cada ebook custa R$19. Se for cliente VIP pode gerar quantos ebooks quiser de forma ilimitada.
                    </p>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <br/>
              <b-row>
                <b-col>
                  <b-alert variant="success" class="text-center" show><a href="https://api.whatsapp.com/send?phone=558199719158&text=Tenho%20uma%20d%C3%BAvida%20sobre%20o%20Sleeker%2C%20pode%20me%20ajudar%3F" class="text-success">Clique aqui se você ainda precisa falar conosco</a></b-alert>
                </b-col>
              </b-row>
            </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import service from "../service";


export default {
  name: 'Tutorial',
  data () {
    return {
      me: undefined,
      isMobileScreen: isMobile,
      tutorials:  [],
    }
  },
  computed: {
    templateName() {
      return localStorage.templateName;
    },
    whitelabelName() {
      return localStorage.whitelabelName;
    },
    youtubeTutorial() {
      return localStorage.youtubeTutorial;
    },
    number() {
      return this.$route.params.number;
    }
  },
  methods: {
    goToSearch: function() {
      this.$router.push({ name: 'Busca', params: { page: 1 }});
    }
  },
  mounted() {
    if (this.number) {
      console.log(this.$refs["accordion" + this.number]);
      this.$refs["accordion" + this.number].focus()
    }
  },
  created() {
    console.log("gtag ok");
    service.getTutorials().then((result) => {
      if (result && result.tutorials && result.tutorials.length)
        this.tutorials = result.tutorials;
      }
    );
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.row-eq-height {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
</style>
